import React from 'react';
import { Select } from 'antd';
import { BloodType } from '../../../types/user.types';

interface BloodTypeSelectProps {
  value?: BloodType;
  onChange?: (value: BloodType) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
}

const BloodTypeSelect: React.FC<BloodTypeSelectProps> = ({
  value,
  onChange,
  placeholder = "Kan grubu seçiniz",
  className,
  disabled = false
}) => {
  const bloodTypeOptions = [
    { value: BloodType.A_POSITIVE, label: 'A+' },
    { value: BloodType.A_NEGATIVE, label: 'A-' },
    { value: BloodType.B_POSITIVE, label: 'B+' },
    { value: BloodType.B_NEGATIVE, label: 'B-' },
    { value: BloodType.AB_POSITIVE, label: 'AB+' },
    { value: BloodType.AB_NEGATIVE, label: 'AB-' },
    { value: BloodType.O_POSITIVE, label: 'O+' },
    { value: BloodType.O_NEGATIVE, label: 'O-' },
    { value: BloodType.UNKNOWN, label: 'Bilinmiyor' },
  ];

  return (
    <Select
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={className}
      disabled={disabled}
      allowClear
      showSearch
      optionFilterProp="label"
      style={{ width: '100%' }}
    >
      {bloodTypeOptions.map((option) => (
        <Select.Option key={option.value} value={option.value} label={option.label}>
          {option.label}
        </Select.Option>
      ))}
    </Select>
  );
};

export default BloodTypeSelect; 